import Rest from '../Rest'

export default class RequestFormLgpdService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/request_form_lgpd'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }

  getListLegalEntity(paramEncrypt: String) {
    return this.get(`legal_entity/${paramEncrypt}`).then(data => {
      return data
    })
  }
}
